import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import { BiEdit, BiTrash } from "react-icons/bi";
import BaseDialog from "../dialogs/BaseDialog";
import ConfirmationModal from "../dialogs/ConfirmationModal";
import CommentDialog from "../dialogs/CommentDialog";
import { useRef, useState } from "react";
import useDialog from "@/hooks/dialog";
import { useDeleteComment } from "@/hooks/api/comments";
import { enqueueSnackbar } from "notistack";

const ReplyComment = ({ replies = [], id }) => {
  const { mutate, isPending } = useDeleteComment();
  const modalRef = useRef(null);
  const { openModal, closeModal } = useDialog(modalRef);

  const [comment, setComment] = useState({});

  const confirmModalRef = useRef(null);
  const {
    openModal: openConfirmationModal,
    closeModal: closeConfirmationModal,
  } = useDialog(confirmModalRef);

  return (
    <>
      {replies?.length > 0 &&
        replies.map((item, index) => (
          <Box
            sx={{ display: "flex", gap: 1, px: { xs: 2, sm: 4, md: 6 } }}
            key={index}
          >
            <Avatar src={item.user?.avatar} sx={{ width: 60, height: 60 }} />
            <Stack sx={{ mt: 3, width: "100%", gap: 1 }}>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Typography fontWeight={600}>
                  {item.user?.fullName || "ناشناس"}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.time}
                </Typography>
                <Box sx={{ ml: "auto" }}>
                  {item.isOwner && (
                    <>
                      <IconButton
                        size="small"
                        color="secondary"
                        onClick={() => {
                          setComment(item);
                          openModal();
                        }}
                      >
                        <BiEdit />
                      </IconButton>
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setComment(item);
                          openConfirmationModal();
                        }}
                      >
                        <BiTrash />
                      </IconButton>
                    </>
                  )}
                </Box>
              </Box>

              <Typography color="text.secondary">{item.content}</Typography>
            </Stack>
          </Box>
        ))}

      <BaseDialog ref={modalRef} title="ویرایش نظر">
        <CommentDialog
          closeModal={closeModal}
          type="course"
          id={id}
          commentId={comment._id}
          content={comment.content}
          lastRate={comment.rate}
          isUpdate
          isReply
        />
      </BaseDialog>

      <BaseDialog ref={confirmModalRef} title="حذف نظر">
        <ConfirmationModal
          openModal={openConfirmationModal}
          closeModal={closeConfirmationModal}
          disabled={isPending}
          data={{
            title: "حذف نظر",
            content: "جهت حذف نظر مطمئن هستید؟",
            cancelBtn: "خیر",
            submitBtn: "بله، مطمئنم",
            submitFunc: () => {
              mutate(
                { data: { commentId: comment._id } },
                {
                  onSuccess: () => {
                    enqueueSnackbar({
                      variant: "success",
                      message: "نظر شما با موفقیت حذف شد",
                    });
                    closeConfirmationModal();
                  },
                }
              );
            },
          }}
        />
      </BaseDialog>
    </>
  );
};

export default ReplyComment;
